import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { GeneralSettings } from 'app/profile/models/generic.model';
import { AuthData } from '@tesla/ng-auth';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { Store } from '@ngrx/store';
import { GetSupplierProfileCurrentUser } from 'app/profile/store/app.actions';


@Component({
    selector: 'app-comment-data-dialog',
    templateUrl: './comment-data-dialog.component.html',
    styleUrls: ['./comment-data-dialog.component.scss']
})
export class CommentDataDialog implements OnInit {
    settings: GeneralSettings;
    showCMTChanges: any;

    get comment(): string { return this.data.comment; }
    get date(): Date { return this.data.date; }
    get name(): string { return this.data.name; }
    get submission(): boolean { return this.data.submissionState; }

    constructor(private fb: FormBuilder,
        private authData: AuthData,
        private supplierStore: Store<SupplierState>,
        public dialogRef: MatDialogRef<CommentDataDialog>,
        @Inject(MAT_DIALOG_DATA) public data:
            {
                submissionState: boolean,
                name: string,
                date: Date,
                comment: string,
            }) {
    }

    ngOnInit() {
        const userInfo = this.authData.getUserInfo();
        this.supplierStore.dispatch(new GetSupplierProfileCurrentUser());
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
